import axios from 'axios';
import { BASE_URL } from './config';
// import { deleteCookie, getCookie } from 'cookies-next'
const api = axios.create({
  baseURL: BASE_URL,
});
const cancelToken = () => axios.CancelToken.source();

if (typeof window !== 'undefined') {
  const token = window.localStorage.getItem('admintoken');
  api.defaults.headers.common.Authorization = token;
  // api.defaults.headers['ngrok-skip-browser-warning'] = "69420"
}
console.log('BASE_URL',BASE_URL)
api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);
api.interceptors.response.use(
  (response) =>
    response,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem('admintoken')) {
      
      // alert('session expired')
      // localStorage.clear();
      // deleteCookie('auth');
      // window.location = '/';
    }
    if (error?.response?.status === 404) {
      console.log('unauthorized', error.response);
    }
    return Promise.reject(error);
  }
);
export { api as axios, cancelToken };
